import React, { useEffect, useState } from 'react';
import {
    Box,
    Collapse,
    TableRow,
    TableCell,
    IconButton,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EmailEchoBuilder from './emailEchoBuilder';
import { ECHO_TYPE } from '../../../../../constants';

function EmailEchoRow(props) {
    const { id, message, subject, duration, type } = props;
    const [open, setOpen] = useState(false);
    return (
        <>
            <TableRow className="echo-row" key={'email-echo-row-'+id}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{id}</TableCell>
                <TableCell>{subject}</TableCell>
                <TableCell>{duration}</TableCell>
                <TableCell>{ECHO_TYPE[type]}</TableCell>
            </TableRow>
            <TableRow key={'email-echo-row-details-'+id}>
                <TableCell className="py-0" colSpan={5}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <EmailEchoBuilder
                                id={id}
                                subject={subject}
                                message={message}
                                duration={duration}
                                type={type}
                                handleEchoRowState={() => setOpen(!open)}
                            />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

export default EmailEchoRow;
